export default __webpack_public_path__ + "static/media/dokumenty-2-fill.3324b846.svg";